export default {
  'common': {
    'add': 'Ajouter',
    'cancel': 'Annuler',
    'description': 'La description',
    'delete': 'Effacer',
    'title': 'Titre',
    'save': 'sauver',
    'faq': 'FAQ',
    'contact': 'Nous contacter',
    'tos': 'Conditions d\'utilisation',
    'policy': 'Politique de confidentialité'
  },
  'board': {
    'titlePlaceholder': 'Entrez un titre pour cette carte',
    'deleteDescription': 'Voulez-vous vraiment supprimer cette carte?',
    'editCard': 'Modifier la carte',
    'deleteCard': 'Supprimer la carte',
    'state': {
      'TODO': 'FAIRE',
      'INPROGRESS': 'EN COURS',
      'TESTING': 'ESSAI',
      'DONE': 'TERMINÉ'
    }
  },
  'chat': {
    'online': 'Utilisateurs en ligne ({count})',
    'addChannel': 'Ajouter une chaîne',
    'channel': 'Channel | Chaînes',
    'message': 'Message'
  },
  'email': {
    'compose': 'Écrire un email',
    'send': 'Envoyer',
    'subject': 'Matière',
    'labels': 'Étiquettes',
    'emptyList': 'Liste de diffusion vide',
    'inbox': 'Boîte de réception',
    'sent': 'Expédié',
    'drafts': 'Brouillons',
    'starred': 'Favoris',
    'trash': 'Poubelle',
    'work': 'Travail',
    'invoice': 'Facture d\'achat'
  },
  'todo': {
    'addTask': 'Ajouter une tâche',
    'tasks': 'Tâches',
    'completed': 'Terminé',
    'labels': 'Étiquettes'
  },
  'dashboard': {
    'activity': 'Activité',
    'weeklySales': 'Ventes hebdomadaires',
    'sales': 'Ventes',
    'recentOrders': 'Dernières commandes',
    'sources': 'Sources de trafic',
    'lastweek': 'vs la semaine dernière',
    'orders': 'Ordres',
    'customers': 'Les clients',
    'tickets': 'Billets d\'assistance',
    'viewReport': 'Voir le rapport'
  },
  'usermenu': {
    'profile': 'Profil',
    'signin': 'Se connecter',
    'dashboard': 'Tableau de bord',
    'signout': 'Déconnexion'
  },
  'error': {
    'notfound': 'Page non trouvée',
    'other': 'Une erreur s\'est produite'
  },
  'check': {
    'title': 'Definir un nouveau mot de passe',
    'backtosign': 'Retour à la connexion',
    'newpassword': 'nouveau mot de passe',
    'button': 'Définissez un nouveau mot de passe et connectez-vous',
    'error': 'Le lien d\'action n\'est pas valide',
    'verifylink': 'Vérification du lien ...',
    'verifyemail': 'Vérification de l\'adresse e-mail ...',
    'emailverified': 'Email verifié! Redirection ...'
  },
  'forgot': {
    'title': 'Mot de passe oublié?',
    'subtitle': 'Entrez l\'adresse e-mail de votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    'email': 'Email',
    'button': 'Demander la réinitialisation du mot de passe',
    'backtosign': 'Retour à la connexion'
  },
  'login': {
    'title': 'Se connecter',
    'email': 'Email',
    'password': 'Mot de passe',
    'button': 'Se connecter',
    'orsign': 'Ou connectez-vous avec',
    'forgot': 'Mot de passe oublié?',
    'noaccount': 'Vous n\'avez pas de compte?',
    'create': 'Créez-en un ici',
    'error': 'La combinaison e-mail / mot de passe n\'est pas valide'
  },
  'register': {
    'title': 'Créer un compte',
    'name': 'Nom complet',
    'email': 'Email',
    'password': 'Mot de passe',
    'button': 'Créer un compte',
    'orsign': 'Ou inscrivez-vous avec',
    'agree': 'En vous inscrivant, vous acceptez le',
    'account': 'Vous avez déjà un compte?',
    'signin': 'Se connecter'
  },
  'utility': {
    'maintenance': 'En maintenance'
  },
  'faq': {
    'call': 'Vous avez d\'autres questions? Veuillez contacter'
  },
  'ecommerce': {
    'products': 'Des produits',
    'filters': 'Filtres',
    'collections': 'Les collections',
    'priceRange': 'Échelle des prix',
    'customerReviews': 'Avis des clients',
    'up': 'et jusqu\'à',
    'brand': 'Marque',
    'search': 'Rechercher un produit',
    'results': 'Résultats ({0} sur {1})',
    'orders': 'Ordres',
    'shipping': 'livraison',
    'freeShipping': 'Livraison gratuite',
    'inStock': 'En stock',
    'quantity': 'Quantité',
    'addToCart': 'Ajouter au chariot',
    'buyNow': 'Acheter maintenant',
    'price': 'Prix',
    'about': 'À propos de cet article',
    'description': 'La description',
    'reviews': 'Commentaires',
    'details': 'détails du produit',
    'cart': 'Chariot',
    'summary': 'Récapitulatif de la commande',
    'total': 'Total',
    'discount': 'Remise',
    'subtotal': 'Total',
    'continue': 'Continuer vos achats',
    'checkout': 'Check-out'
  },
  'menu': {
    'search': 'Recherche (appuyez sur \'ctrl + /\' pour faire la mise au point)',
    'dashboard': 'Tableau de bord',
    'logout': 'Se déconnecter',
    'profile': 'Profil',
    'blank': 'Page blanche',
    'pages': 'Des pages',
    'others': 'Autres',
    'email': 'Email',
    'chat': 'Bavarder',
    'todo': 'Faire',
    'board': 'Tableau des tâches',
    'users': 'Utilisateurs',
    'usersList': 'liste',
    'usersEdit': 'Éditer',
    'ecommerce': 'Commerce électronique',
    'ecommerceList': 'Des produits',
    'ecommerceProductDetails': 'détails du produit',
    'ecommerceOrders': 'Ordres',
    'ecommerceCart': 'Chariot',
    'auth': 'Pages d\'authentification',
    'authLogin': 'Connexion / Connexion',
    'authRegister': 'Inscription / Inscription',
    'authVerify': 'Vérifier les courriels',
    'authForgot': 'Mot de passe oublié',
    'authReset': 'réinitialiser le mot de passe',
    'errorPages': 'Pages d\'erreur',
    'errorNotFound': 'Non trouvé / 404',
    'errorUnexpected': 'Inattendu / 500',
    'utilityPages': 'Pages utilitaires',
    'utilityMaintenance': 'Entretien',
    'utilitySoon': 'Bientôt disponible',
    'utilityHelp': 'FAQ / Aide',
    'levels': 'Niveaux de menu',
    'disabled': 'Menu désactivé',
    'docs': 'Documentation',
    'feedback': 'Retour d\'information',
    'support': 'Soutien',
    'landingPage': 'Page de destination',
    'pricingPage': 'Page de tarification'
  },
  '$vuetify': {
    'badge': 'Badge',
    'close': 'Fermer',
    'dataIterator': {
      'noResultsText': 'Aucun enregistrements correspondants trouvés',
      'loadingText': 'Chargement des éléments ...'
    },
    'dataTable': {
      'itemsPerPageText': 'Lignes par page:',
      'ariaLabel': {
        'sortDescending': 'Tri par ordre décroissant.',
        'sortAscending': 'Tri par ordre croissant.',
        'sortNone': 'Pas trié.',
        'activateNone': 'Activez pour supprimer le tri.',
        'activateDescending': 'Activez pour trier par ordre décroissant.',
        'activateAscending': 'Activez pour trier par ordre croissant.'
      },
      'sortBy': 'Trier par'
    },
    'dataFooter': {
      'itemsPerPageText': 'Objets par page:',
      'itemsPerPageAll': 'Tout',
      'nextPage': 'Page suivante',
      'prevPage': 'Page précédente',
      'firstPage': 'Première page',
      'lastPage': 'Dernière page',
      'pageText': '{0} - {1} sur {2}'
    },
    'datePicker': {
      'itemsSelected': '{0} sélectionné',
      'nextMonthAriaLabel': 'Le mois prochain',
      'nextYearAriaLabel': 'L\'année prochaine',
      'prevMonthAriaLabel': 'Le mois précédent',
      'prevYearAriaLabel': 'Année précédente'
    },
    'noDataText': 'Pas de données disponibles',
    'carousel': {
      'prev': 'Visuel précédent',
      'next': 'Visuel suivant',
      'ariaLabel': {
        'delimiter': 'Diapositive du carrousel {0} sur {1}'
      }
    },
    'calendar': {
      'moreEvents': '{0} de plus'
    },
    'fileInput': {
      'counter': '{0} fichiers',
      'counterSize': '{0} fichiers ({1} au total)'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'Navigation par pagination',
        'next': 'Page suivante',
        'previous': 'Page précédente',
        'page': 'Aller à la page {0}',
        'currentPage': 'Page actuelle, page {0}'
      }
    }
  }
}